<div>
  <div class="title">Select the account to pay from:</div>

  @for(account of accounts; track account.id) {
    <div class="account">
      <div>Nickname: <span>{{account.name}}</span></div>
      <div>Bank: <span>{{account.bankName}}</span></div>
      <div>Type: <span class="bank-type">{{account.bankAccountType}}</span></div>

      <div class="action-section">
        <div class="remove" (click)="removeAccount(account.id)">Remove</div>
        <button mat-raised-button color="primary" class="full-witdh" type="button" (click)="selectAccount(account.id)" [disabled]="loading">
          PAY WITH THIS ACCOUNT
        </button>
      </div>
    </div>
  }

</div>